module.exports = __webpack_public_path__ + "media/images/newsletter-bg-222fc5d8cd21696c7b229161f4791120.jpg";